import { AppApiError } from '@modules/husleie-framework/src/types/App.entity';
import { Modals } from '@modules/husleie-framework/src/types/Modals.entity';
import type { StaticDataType } from '@modules/store/common/enums/StaticDataType.enum';
import type CommonState from '@modules/store/common/types/CommonState.entity';
import type StaticDataState from '@modules/store/common/types/StaticDataState.entity';
import type TranslationOption from '@modules/store/common/types/TranslationOption.entity';
import { GetterTree } from 'vuex';

export const getters: GetterTree<StaticDataState, CommonState> = {
  getLoading(state): boolean {
    return state.loading;
  },
  getApiError(state): AppApiError {
    return state.api.errorStatus;
  },
  getLocale(state): string {
    return state.locale;
  },
  getLanguage(state): string {
    return state.language;
  },
  getTimezone(state): string {
    return state.timezone;
  },
  getTranslationOptions(state) {
    return (type: StaticDataType): TranslationOption[] => {
      return state.translations
        .filter(translation => translation.type === type)
        .map(translation => {
          return {
            name: translation.translation,
            value: translation.name,
          };
        });
    };
  },
  getTranslation(state) {
    return (type: StaticDataType, name: string): undefined | string => {
      return state.translations.find(translation => translation.type === type && translation.name === name)
        ?.translation;
    };
  },
  getModalName(state): Modals {
    return state.modal.name;
  },
  getModalIsOpen(state): boolean {
    return state.modal.open;
  },
  getModalIsCloseable(state): boolean {
    return state.modal.closeable;
  },
};
